import { TagContentTypeEnum } from '@/entities/tags'

export type TagsListPageTabsKeys = Lowercase<keyof typeof TagContentTypeEnum>

export const DEFAULT_TAGS_LIST_PAGE_TAB: TagsListPageTabsKeys = 'music'

export const TagsListPageTabsKeysTypesEnum: Record<
  TagsListPageTabsKeys,
  TagContentTypeEnum
> = {
  music: TagContentTypeEnum.Music,
  podcast: TagContentTypeEnum.Podcast,
  audiobook: TagContentTypeEnum.AudioBook,
  album: TagContentTypeEnum.Album,
  mood: TagContentTypeEnum.Mood,
}

export const TagsListPageTabsKeysArray: TagsListPageTabsKeys[] = [
  'music',
  'podcast',
  'audiobook',
  'album',
  'mood',
]

export const TagsListPageTabsKeysEnum: Record<
  TagsListPageTabsKeys,
  TagsListPageTabsKeys
> = {
  music: 'music',
  podcast: 'podcast',
  audiobook: 'audiobook',
  album: 'album',
  mood: 'mood',
}
